
export const unassignedAppointments = (
    { setModalData }: {
        setModalData?: (data: { modalType: string; data: { id: number | undefined } }) => void
    }) => {
    return [
        {
            Header: "Date",
            accessor: (row: any) => row?.date ? new Date(row?.date) : 'date',
            Cell: ({ row }: any) => {
                
                const date = row.original.date;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {date ? new Date(date).toLocaleDateString("de") : "Not available"}
                    </span>
                );
            },
            id: 1,
            isChecked: true,
        },
        {
            Header: "Time",
            accessor: "time",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {row.original.time || "Not available"}
                    </span>
                );
            },
            id: 2,
            isChecked: true,
        },
        {
            Header: "Name",
            accessor: "info",
            Cell: ({ row }: any) => {
                
                const { first_name, last_name } = row.original.info;
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {first_name} {last_name}
                    </span>
                );
            },
            id: 3,
            isChecked: true,
        },
        {
            Header: "Phone",
            accessor: "info.phone_number",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {row.original.info.phone_number || "Not available"}
                    </span>
                );
            },
            id: 4,
            isChecked: true,
        },
        {
            Header: "City",
            accessor: "info.city",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {row.original.info.city || "Not available"}
                    </span>
                );
            },
            id: 5,
            isChecked: true,
        },
        {
            Header: "Address",
            accessor: "info.address",
            Cell: ({ row }: any) => {
                
                return (
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalData && setModalData({ modalType: "appointments", data: { id: row.original.id } })}
                    >
                        {row.original.info.address || "Not available"}
                    </span>
                );
            },
            id: 6,
            isChecked: true,
        },
    ];
}
